import { BaseCommonIndicatorChart, CommonIndicator, CommonIndicatorChartInfo } from '@solvace/core/models';

export enum InspectionIndicatorCategory {
  LATE = 1,
  TODAY = 2,
}
export enum InspectionIndicatorCategoryNames {
  'Atrasado' = 1,
  'Hoje' = 2,
}

export enum InspectionIndicatorStatus {
  PENDING = 3,
  PERFORMED = 1,
}

export enum InspectionIndicatorStatusNames {
  'Pendente' = 3,
  'Realizado' = 1,
}

export enum InspectionIndicatorStatusColors {
  '#9BA0A3' = 3,
  '#4D4D4D' = 1,
}

export enum InspectionIndicatorStatusBadge {
  OPEN = 10,
  INAPPROVAL = 20,
  COMPLETED = 30,
}

export class InspectionIndicator extends BaseCommonIndicatorChart {
  data: CommonIndicator;
  chartInfo: CommonIndicatorChartInfo;
  chartOrder = [2, 1];
  seriesOrder = [3, 1];

  constructor(data: CommonIndicator) {
    super({
      statuses: InspectionIndicatorStatus,
      statusesNames: InspectionIndicatorStatusNames,
      categories: InspectionIndicatorCategory,
      categoriesNames: InspectionIndicatorCategoryNames,
      colors: InspectionIndicatorStatusColors,
    });
    this.data = data;
    this.chartInfo = this.generateChartInfo();
  }
}
